import { ScheduledErrorView } from '../components/scheduled-error-view';

export const ScheduledAdminError = () => {
  const handleRetry = () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  return <ScheduledErrorView onRetry={handleRetry} />;
};
